import VueCookie from 'vue-cookie';
import axios, { AxiosInstance } from 'axios';
import { ENDPOINTS } from '@/settings/endpoints';
import SentryClient from '@/helpers/sentry';

export interface CollaborationResponse<T> {
  data: T;
  message: string;
  identifier: string;
}
export interface DataResponseDto {
  email: string;
  service_index: string;
  service_data: string;
}

export interface DataDto {
  email: string;
  serviceIndex: string;
  serviceData: any;
}

export interface PutDataInputDto {
  email: string;
  serviceIndex: string;
  serviceData: string;
}

export interface GetDataInputDto {
  email: string;
  serviceIndex: string;
}

export class GrowthDataHubService {
  private gateway: AxiosInstance;

  constructor() {
    const tokenD = VueCookie.get('d', { domain: '.descomplica.com.br' });

    this.gateway = axios.create({
      baseURL: `${ENDPOINTS.pegasusSilver}growth/data-hub`,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${tokenD}`,
      },
    });
  }

  async getData(input: GetDataInputDto): Promise<DataDto> {
    try {
      const {
        data: { data },
      } = await this.gateway.get<CollaborationResponse<DataResponseDto>>(
        `/data/${input.email}/${input.serviceIndex}?email=${input.email}`,
      );

      return {
        ...data,
        serviceData: JSON.parse(data.service_data),
        serviceIndex: data.service_index,
      };
    } catch (error) {
      SentryClient.captureError(error);
      return { ...input, serviceData: {} };
    }
  }

  async putData(input: PutDataInputDto): Promise<DataDto> {
    try {
      const {
        data: { data },
      } = await this.gateway.post<CollaborationResponse<DataResponseDto>>(`/data`, input);

      return {
        email: data.email,
        serviceData: JSON.parse(data.service_data),
        serviceIndex: data.service_index,
      };
    } catch (error) {
      SentryClient.captureError(error);
      return { ...input, serviceData: {} };
    }
  }
}
